import Layout from "../../Internal/Layout.vue";
import PromotionsCenter from "./PromotionsCenter.vue";
import Promotion from "./components/Promotion.vue";

const ResaleStockRoutes = {
  component: Layout,
  children: [
    {
      path: "/promotions-center",
      name: "PromotionsCenter",
      component: PromotionsCenter,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresManagerial: true,
      },
    },
    {
      path: "/promotion",
      name: "Promotion",
      component: Promotion,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresManagerial: true,
        requiresResale: true,
      },
    },
  ],
};

export default ResaleStockRoutes;
